import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { kycEndpoints } from "@/features/kyc/api/endpoints";
import type { PartyDto, PartyFilter } from "@/features/kyc/api/dto";

/**
 * Liste paginée des identités (`POST /Parties/all` — les listes sont en
 * POST, guide §4.2). Lecture authentifiée : `mutateData` en queryFn, la
 * requête reste une query TanStack (cache, invalidation).
 */
export const useParties = (params: ListRequest<PartyFilter> = {}, enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.KYC_PARTIES_LIST(params),
    queryFn: () =>
      mutateData({
        url: kycEndpoints.parties.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<PartyDto>>,
    enabled,
  });
